import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../Redux/Store/index.ts";
import { allGet } from "../Redux/Actions.tsx";
import { urlcommittenti, urlmetodi } from "../lib/api.ts";
import SideBar from "../Components/SideBar.tsx";
import { Col, Container, Row } from "react-bootstrap";
import "./Home.css";
import Tabelle from "../Components/Table.tsx";
import { CantieriColumns } from "../lib/ColonneTabelle.ts";
import Header from "../Components/Header.tsx";
import MiniCalendar from "../Components/MiniCalendar.tsx";
import ToDoHome from "../Components/ToDoHome.tsx";
import { useNavigate } from "react-router-dom";
import { Cantieri } from "../lib/interface.ts";

interface CalendarEvent {
  title: string;
  date: string;
  eventType: string;
  eventData: any;
  colorText: string;
}

const Home: React.FC = () => {
  const { token, profilo } = useSelector((state: RootState) => state.login);
  const cantieri = useSelector((state: RootState) => state.cantieri.cantieri);
  const committenti = useSelector((state: RootState) => state.committenti.committenti);
  const contratti = useSelector((state: RootState) => state.contratti.contratti);
  const eventi = useSelector((state: RootState) => state.eventi.eventi);
  const stati = useSelector((state: RootState) => state.stati.stati);
  const dispatch: AppDispatch = useDispatch();
  const navigate = useNavigate();
  const tasks = useSelector((state: RootState) => state.task.task);
  useEffect(() => {
    dispatch(allGet(urlcommittenti, token));
    dispatch(allGet(urlmetodi, token));
  }, [dispatch, token]);
  const getColorBadge = (stato: string) => {
    console.log(stati);
    const singoloStato = stati.find((s) => s.id == stato);
    console.log(singoloStato);
    if (singoloStato) {
      return "#" + singoloStato.colore;
    } else return "grey";
  };

  const events = useMemo(() => {
    const tasksEvents = tasks
      .filter((task) => task.scadenza)
      .filter((task) => task.assegnatoA === profilo.id)
      .map((task) => ({
        title: task.titolo,
        date: new Date(task.scadenza).toISOString().split("T")[0],
        eventType: "red-dot",
        colorText: "red-text",
        eventData: task,
      }));

    const eventoEvents = eventi
      .filter((evento) => evento.dataEsecuzione)
      .map((evento) => ({
        title: evento.titolo,
        date: new Date(evento.dataEsecuzione).toISOString().split("T")[0],
        eventType: "blue-dot",
        colorText: "blue-text",
        eventData: evento,
      }));
    return [...tasksEvents, ...eventoEvents];
  }, [tasks, eventi]);

  const [selectedDate, setSelectedDate] = useState<string | null>(null);
  const [selectedEvents, setSelectedEvents] = useState<CalendarEvent[]>([]);

  const handleDateClick = (date: string) => {
    const eventsForDate = events.filter((event) => event.date === date);

    setSelectedEvents(eventsForDate);
    setSelectedDate(date);
  };

  const [cantieriTable, setCantieriTable] = useState<Cantieri[]>([]);

  const cantieriConDati = useMemo(() => {
    const today = new Date();
    return cantieri
      .filter((cantiere) => {
        if (!cantiere.dataFineEffettiva) {
          return true; // Includi cantieri senza dataFineEffettiva
        }
        const dataFineEffettiva = new Date(cantiere.dataFineEffettiva);
        return dataFineEffettiva > today; // Includi solo i cantieri con dataFineEffettiva futura
      })
      .map((cantiere) => ({
        ...cantiere,
        codiceContratto: contratti.find((contratto) => contratto.id === cantiere.contrattoQuadro)?.codice || "N/A",
        nomeReferente: contratti.find((contratto) => contratto.id === cantiere.contrattoQuadro)?.referenti?.[0]
          ? `${contratti.find((contratto) => contratto.id === cantiere.contrattoQuadro)?.referenti?.[0]?.nome} ${
              contratti.find((contratto) => contratto.id === cantiere.contrattoQuadro)?.referenti?.[0]?.cognome
            }`
          : "Nessun referente",
        subappalto: cantiere.subappalto === "true" ? "Sì" : "No",
        statoBadge: cantiere.stato?.toLowerCase() || "default",
        importo: new Intl.NumberFormat("it-IT", {
          style: "currency",
          currency: "EUR",
          minimumFractionDigits: 2,
        }).format(cantiere.importo || 0),
      }));
  }, [cantieri, contratti]);

  useEffect(() => {
    setCantieriTable(cantieriConDati);
  }, [cantieriConDati]);
  const getLabelStato = (stato: string) => {
    const singoloStato = stati.find((s) => s.id == stato);
    if (singoloStato) return singoloStato.stato;
    else return "nessuno stato";
  };

  return (
    <Container fluid className="d-flex justify-content-between" style={{ margin: "0", padding: "0" }}>
      <Container fluid style={{ margin: "0", padding: "0", width: "5%" }}>
        <SideBar />
      </Container>
      <Container fluid className="colonna ">
        <div className="d-flex justify-content-center">
          <Header
            title={"Buongiorno, " + profilo.nome}
            buttons={[
              {
                label: "Aggiungi un nuovo cantiere",
                onClick: () => {
                  if (committenti.length === 0) {
                    navigate("/cantieri");
                  } else {
                    navigate("/crea/cantieri");
                  }
                },
              },
              {
                label: "Aggiungi un nuovo evento",
                onClick: () => {
                  if (committenti.length === 0) {
                    navigate("/eventi");
                  } else {
                    navigate("/crea/eventi");
                  }
                },
              },
            ]}
          />
        </div>

        <div className="d-flex justify-content-center ">
          <Row className="g-3 w-90-95">
            <Col xs={5} className="ps-0 p-0">
              <div className="home-calendar-task d-flex justify-content-center align-items-center">
                <MiniCalendar onDateClick={handleDateClick} events={events} selectedDate={selectedDate} />
              </div>
              <div className="calendar-legend">
                <div>
                  <span className="event-dot red-dot"></span> Tasks
                </div>
                <div>
                  <span className="event-dot blue-dot"></span> Eventi
                </div>
              </div>
            </Col>
            <Col xs={7} className="pe-0">
              <div className="home-calendar-task" style={{ overflow: "auto" }}>
                <ToDoHome events={selectedEvents} selectedDate={selectedDate} />
              </div>
            </Col>
            <Col xs={12} className="px-0">
              <h3 style={{ paddingBlockStart: "1rem" }}>Cantieri:</h3>
              <div className="table-card-home">
                <Tabelle
                  id="tabella-home"
                  data={cantieriTable.map((cantiere) => ({
                    ...cantiere,
                    stato: (
                      <div
                        className="badge"
                        style={{ backgroundColor: getColorBadge(cantiere.stato) }}
                        aria-label={`Stato: ${cantiere.stato}`}
                      >
                        {getLabelStato(cantiere.stato) || "-"}
                      </div>
                    ),
                  }))}
                  columns={CantieriColumns}
                  type={"cantieri"}
                />
              </div>
            </Col>
          </Row>
        </div>
      </Container>
    </Container>
  );
};

export default Home;
